import { useNavigate } from 'react-router-dom';

import { KioskFrame } from '../components/KioskFrame';
import { OptionCard } from '../components/OptionCard';
import { LOCALES } from '../lib/i18n';
import { useKiosk } from '../lib/session';

/** 語言選擇 — Flow 3.2。選定後進首頁。 */
export function LanguageScreen(): JSX.Element {
  const navigate = useNavigate();
  const { setLocale, t } = useKiosk();

  return (
    <KioskFrame>
      <h1 className="k-h1">{t('language.title')}</h1>
      {LOCALES.map((l) => (
        <OptionCard
          key={l.code}
          title={l.label}
          onClick={() => {
            setLocale(l.code);
            navigate('/home');
          }}
        />
      ))}
    </KioskFrame>
  );
}
